const MOSTERD_LOGO = '/assets/logo.svg';
const FALLBACK_LOGO = 'https://app.evidend.nl/images/svg/favicon-512x512.svg';

// Mosterd branding only applies on the mosterd.com domain family; every other host (e.g. white-label domains) falls back to the Evidend logo.
export function getDefaultLogo(): string {
  const host = window.location.hostname;
  return host === 'mosterd.com' || host.endsWith('.mosterd.com') ? MOSTERD_LOGO : FALLBACK_LOGO;
}
